import {Dispatch} from "redux";

import {apiLink} from "../../app/routes/api_link";
import {IServices} from "../../app/services/IServices";
import {createRequestActionTypes} from "../../app/utils/request_response_utils/factories/create_request_action_types";
import {getRequest} from "../../app/utils/request_response_utils/request";
import {fetchInitialSearchDataTypes} from "./fetch_initial_search_data";

export interface ICarsMakesSearch {
    make: string;
    count: number;
}
interface ICarsMakeSearchResponse {
    data: ICarsMakesSearch[];
}

export const fetchAllMakesForSearch = createRequestActionTypes({view: "Home", type: "GET", name: "CarsAllMakesForSearch"});

const normalizeMakes = (json: unknown): ICarsMakesSearch[] => {
    if (Array.isArray(json)) {
        return json as ICarsMakesSearch[];
    }
    if (json && typeof json === "object" && Array.isArray((json as ICarsMakeSearchResponse).data)) {
        return (json as ICarsMakeSearchResponse).data;
    }
    return [];
};

/** Homepage search button only needs total offers — sum make counts instead of slow get-cars-search. */
const seedOfferCountFromMakes = (dispatch: Dispatch, makes: ICarsMakesSearch[]) => {
    const count = makes.reduce((sum, make) => sum + (Number(make.count) || 0), 0);
    dispatch({
        type: fetchInitialSearchDataTypes.success,
        result: {
            count,
            model: [],
            body_type: [],
            engine: [],
            year: []
        }
    });
};

export const fetchMakesDataForSearch =
    (services: Partial<IServices>) =>
    (dispatch: Dispatch): Promise<ICarsMakeSearchResponse | boolean> => {
        dispatch({type: fetchAllMakesForSearch.start});
        const url = apiLink.searchMakes({})(null);
        return getRequest(services, url, "fetchMakesSearch")
            .then(async (json: unknown) => {
                const makes = normalizeMakes(json);
                dispatch({type: fetchAllMakesForSearch.success, result: {data: makes}});
                seedOfferCountFromMakes(dispatch, makes);
                return {data: makes};
            })
            .catch(async (err) => {
                //   console.log("FETCH DETAIL err", err);
                //await dispatch(redirectOrEnable404ResponseState(services, route.pathname));
                return false;
            });
    };
